import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-case-list',
    templateUrl: './case-list.component.html',
    styleUrls: ['./case-list.component.scss'],
    standalone: false
})
export class CaseListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
